<!-- src/views/ContractForm.vue -->
<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="900px"
    @close="handleClose"
  >
    <el-form
      ref="formRef"
      :model="localFormData"
      :rules="formRules"
      label-width="120px"
      size="medium"
      label-position="right"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="合同编号" prop="contractNo">
            <el-input
              v-model="localFormData.contractNo"
              placeholder="请输入合同编号"
              clearable
              :disabled="isEdit"
            />
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="合同主体" prop="contractSubject">
            <el-input
              v-model="localFormData.contractSubject"
              placeholder="请输入合同主体"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="签约开始日期" prop="signStartDate">
            <el-date-picker
              v-model="localFormData.signStartDate"
              type="date"
              placeholder="选择开始日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="签约结束日期" prop="signEndDate">
            <el-date-picker
              v-model="localFormData.signEndDate"
              type="date"
              placeholder="选择结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="租赁楼宇" prop="leaseBuilding">
            <el-input
              v-model="localFormData.leaseBuilding"
              placeholder="请输入租赁楼宇"
              clearable
            />
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="租赁位置" prop="leaseLocation">
            <el-input
              v-model="localFormData.leaseLocation"
              placeholder="请输入租赁位置"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="租赁面积(㎡)" prop="leaseArea">
            <el-input-number
              v-model="localFormData.leaseArea"
              :min="0"
              :precision="2"
              :step="0.01"
              placeholder="请输入租赁面积"
              style="width: 100%"
              @change="calculateFirstYearRent"
            />
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="首年租金单价" prop="firstYearRentUnitPrice">
            <el-input-number
              v-model="localFormData.firstYearRentUnitPrice"
              :min="0"
              :precision="2"
              :step="0.01"
              placeholder="请输入租金单价"
              style="width: 100%"
              @change="calculateFirstYearRent"
            >
              <template slot="append">元/㎡/月</template>
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="首年租金(元)" prop="firstYearRent">
            <el-input
              v-model="localFormData.firstYearRent"
              placeholder="自动计算"
              readonly
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="押金金额(元)" prop="depositAmount">
            <el-input-number
              v-model="localFormData.depositAmount"
              :min="0"
              :precision="2"
              :step="0.01"
              placeholder="请输入押金金额"
              style="width: 100%"
            >
              <template slot="append">元</template>
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="租金支付方式" prop="rentPaymentMethod">
            <el-select
              v-model="localFormData.rentPaymentMethod"
              placeholder="请选择支付方式"
              clearable
              style="width: 100%"
            >
              <el-option label="月付" value="月付" />
              <el-option label="季付" value="季付" />
              <el-option label="半年付" value="半年付" />
              <el-option label="年付" value="年付" />
              <el-option label="一次性支付" value="一次性支付" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="租金政策" prop="rentPolicy">
        <el-input
          v-model="localFormData.rentPolicy"
          type="textarea"
          :rows="3"
          placeholder="请输入租金政策"
          clearable
        />
      </el-form-item>

      <el-form-item label="开票信息" prop="invoiceInfo">
        <el-input
          v-model="localFormData.invoiceInfo"
          type="textarea"
          :rows="3"
          placeholder="请输入开票信息"
          clearable
        />
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="localFormData.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
          clearable
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ContractForm',
  
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
       // 使用本地数据副本，避免直接修改props
      localFormData: {
        contractNo: '',
        contractSubject: '',
        invoiceInfo: '',
        signStartDate: '',
        signEndDate: '',
        leaseBuilding: '',
        leaseLocation: '',
        leaseArea: null,
        firstYearRentUnitPrice: null,
        rentPolicy: '',
        rentPaymentMethod: '',
        firstYearRent: null,
        depositAmount: null,
        remark: ''
      },
      formRules: {
        contractNo: [
          { required: true, message: '请输入合同编号', trigger: 'blur' }
        ],
        contractSubject: [
          { required: true, message: '请输入合同主体', trigger: 'blur' }
        ],
        signStartDate: [
          { required: true, message: '请选择签约开始日期', trigger: 'change' }
        ],
        signEndDate: [
          { required: true, message: '请选择签约结束日期', trigger: 'change' }
        ],
        leaseBuilding: [
          { required: true, message: '请输入租赁楼宇', trigger: 'blur' }
        ],
        leaseLocation: [
          { required: true, message: '请输入租赁位置', trigger: 'blur' }
        ],
        leaseArea: [
          { required: true, message: '请输入租赁面积', trigger: 'blur' }
        ],
        firstYearRentUnitPrice: [
          { required: true, message: '请输入首年租金单价', trigger: 'blur' }
        ]
      }
    }
  },
  
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑合同' : '新增合同'
    }
  },
  
   watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initFormData()
      }
    },
    
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.resetForm()
      }
    },
    
    // 监听父组件传入的formData变化
    formData: {
      handler(newVal) {
        this.initFormData()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
        // 计算首年租金
    calculateFirstYearRent() {
      const { leaseArea, firstYearRentUnitPrice } = this.localFormData
      if (leaseArea && firstYearRentUnitPrice) {
        const rent = leaseArea * firstYearRentUnitPrice * 12
        this.localFormData.firstYearRent = Number(rent.toFixed(2))
      } else {
        this.localFormData.firstYearRent = null
      }
    },
    initFormData() {
      if (this.formData && Object.keys(this.formData).length > 0) {
        // 深拷贝父组件的数据到本地
        this.localFormData = {
          ...this.defaultFormData(),
          ...JSON.parse(JSON.stringify(this.formData))
        }
      } else {
        this.localFormData = this.defaultFormData()
      }
      
      // 计算首年租金
      this.calculateFirstYearRent()
    },
    
    // 默认表单数据
    defaultFormData() {
      return {
        contractNo: '',
        contractSubject: '',
        invoiceInfo: '',
        signStartDate: '',
        signEndDate: '',
        leaseBuilding: '',
        leaseLocation: '',
        leaseArea: null,
        firstYearRentUnitPrice: null,
        rentPolicy: '',
        rentPaymentMethod: '',
        firstYearRent: null,
        depositAmount: null,
        remark: ''
      }
    },
    
    // 关闭对话框
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
      this.$emit('close')
    },
    
    // 重置表单
    resetForm() {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
      this.loading = false
      // 重置表单数据
      Object.keys(this.formData).forEach(key => {
        this.$set(this.formData, key, '')
      })
    },
    // 在 handleSubmit 方法中，确保数据格式正确
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.loading = true
          
          // 验证结束日期不能早于开始日期
          if (this.localFormData.signStartDate && this.localFormData.signEndDate) {
            if (this.localFormData.signEndDate < this.localFormData.signStartDate) {
              this.$message.error('结束日期不能早于开始日期')
              this.loading = false
              return
            }
          }
          
          // 准备提交数据 - 确保格式正确
          const submitData = {}
          
          // 复制所有字段
          Object.keys(this.localFormData).forEach(key => {
            let value = this.localFormData[key]
            
            // 处理空字符串转为 null
            if (value === '') {
              value = null
            }
            
            // 处理数字字段
            const numberFields = ['leaseArea', 'firstYearRentUnitPrice', 'firstYearRent', 'depositAmount']
            if (numberFields.includes(key) && value !== null) {
              value = Number(value)
            }
            
            submitData[key] = value
          })
          
          // 移除前端临时字段
          delete submitData._index
          delete submitData._rowKey
          
          
          // 触发保存事件
          this.$emit('save', submitData)
          
          // 重置loading状态
          this.loading = false
        }
      })
    },
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.el-form-item {
  margin-bottom: 22px;
}

.el-textarea {
  resize: vertical;
}
</style>